import styled from 'styled-components'
import { Icon } from 'components/atoms'

export const Root = styled.div`
  position: fixed;
  bottom: 30px;
  right: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  z-index: ${ (props) => props.theme.zIndices.floatingMenu };
`

export const MenuButton = styled.div`
  height: 60px;
  width: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`

export const MenuButtonIcon = styled(Icon)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${ (props) => (props.open ? '40px' : '60px') };
  height: ${ (props) => (props.open ? '40px' : '60px') };
  background: ${ (props) => props.theme.colors.hellgruen1 };
  border-radius: 50%;
  color: ${ (props) => props.theme.colors.weiss };
  font-size: ${ (props) => (props.open ? '14px' : '24px') };
`
